<template>
   <form class="adminCardBody eval-docente-adm__form" @submit.prevent="createNewGenericFormSubmit">
      <!-- DETALLE FORMULARIO -->
      <div class="titlePage">Detalle del formulario</div>
      <div class="row">
         <div class="col-md-6 form-group">
            <label>Nombre del formulario</label>
            <input
               v-model="formUpdModel.nam_Form"
               type="text"
               placeholder="Ingrese el nombre del formulario"
               required
               />
         </div>
         <div class="col-md-6 form-group">
            <label>Título del formulario</label>
            <input
               v-model="formUpdModel.det_FormTitle"
               type="text"
               placeholder="Ingrese el título del formulario"
               required
               />
         </div>
      </div>
      <div class="row">
         <div class="col-md-12 form-group">
            <label>Descripción del formulario</label>
            <textarea
               v-model="formUpdModel.det_FormBody"
               rows="5"
               placeholder="Ingrese la descripción del formulario"
               required
               ></textarea>
         </div>
      </div>
      <!-- PARAMETRIZACIÓN -->
      <div class="titlePage">Parametrización del formulario</div>
      <div class="row">
         <div class="col-md-6 form-group">
            <label>Fecha de apertura</label>
            <input
               v-model="formUpdModel.date_Form_Start"
               type="date"
               required
               @input="validateFechaFin"
               />
         </div>
         <div class="col-md-6 form-group">
            <label>Fecha de cierre</label>
            <input
               v-model="formUpdModel.date_Form_End"
               type="date"
               required
               ref="fechaFinInput"
               @input="validateFechaFin"
               />
         </div>
      </div>
      <div class="row">
         <div class="col-md-6 form-group">
            <label>Rol del formulario</label>
            <select v-model="formUpdModel.id_Role" required>
               <option disabled value=""></option>
               <option
                  v-for="rol in dataForSelect"
                  :key="rol.id_Role"
                  :value="rol.id_Role"
                  >
                  {{ rol.nam_Role }}
               </option>
            </select>
         </div>
         <div class="col-md-6 form-group">
            <label>Tipo de formulario</label>
            <select v-model="formUpdModel.id_Form_Type" required>
               <option disabled value=""></option>
               <option
                  v-for="typeForm in dataForSelectType"
                  :key="typeForm.id_Form_Type"
                  :value="typeForm.id_Form_Type"
                  >
                  {{ typeForm.form_Type_Desc }}
               </option>
            </select>
         </div>
      </div>
      <div class="row">
         <div class="col-md-6 form-group">
            <label>Periodo</label>
            <input
               v-model="formUpdModel.id_Period"
               type="text"
               placeholder="Ej: 2024"
               required
               ref="periodInput"
               @input="validatePeriod"
               />
         </div>
         <div class="col-md-6 form-group">
            <label>Estado del formulario</label>
            <select v-model="formUpdModel.sta_Form" required>
               <option disabled value=""></option>
               <option value="1">Activo</option>
               <option value="0">Inactivo</option>
            </select>
         </div>
      </div>
      <!-- BOTÓN -->
      <div class="modalActions">
         <button
            type="submit"
            class="loginbtn primaryBtn"
            >
         {{ validationAction ? 'Editar' : 'Crear' }}
         </button>
      </div>
   </form>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
export default{
  name: 'EvalDocenteAdmCreate.vue',
  data () {
    return {
      pElement: '',
      dataForSelect: [],
      dataForSelectType: [],
      formUpdModel: {
        id_Generic_Form: '',
        date_Form_Start: '',
        date_Form_End: '',
        nam_Form: '',
        det_FormTitle: '',
        det_FormBody: '',
        sta_Form: '',
        id_Role: '',
        id_Period: '',
        id_Form_Type: '',
      },
    }
  },
  methods: {
    loadDataSelectRoles () {
      IberoHelpers.GetEvalDocenteAdmRoles(this.$store, 0)
        .then(response => {
          this.dataForSelect = response.data
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
    },

    loadDataSelectTypeForm () {
      IberoHelpers.GetEvalDocenteAdmTypeForm(this.$store, 0)
        .then(response => {
          this.dataForSelectType = response.data
        })
        .catch(error => {
          console.error('Error loading data:', error)
        })
    },
    createNewGenericFormSubmit () {
      this.$emit('OpenConfirmationMessage')

      if (this.validationAction === false) {
        try {
          IberoHelpers.GetEvalDocenteAdmCreate(this.$store, this.formUpdModel)
        } catch (error) {
          console.log(error)
        }
      } else if (this.validationAction === true) {
        try {
          IberoHelpers.GetEvalDocenteAdmEdit(this.$store, this.formUpdModel)
        } catch (error) {
          console.log(error)
        }
      }
    },

    loadEditInformation () {
      if (this.validationAction === true) {
        const parser = new DOMParser()
        const parsedHtml = parser.parseFromString(this.dataEdit.det_Form, 'text/html')

        const h3Element = parsedHtml.querySelector('h3')
        const pElements = parsedHtml.querySelectorAll('p')

        pElements.forEach((pElement) => {
          this.pElement += pElement.textContent
        })

        this.formUpdModel.id_Generic_Form = this.dataEdit.id_Generic_Form
        this.formUpdModel.date_Form_Start = this.dataEdit.date_Form_Start
        this.formUpdModel.date_Form_End = this.dataEdit.date_Form_End
        this.formUpdModel.nam_Form = this.dataEdit.nam_Form
        this.formUpdModel.det_FormTitle = h3Element.textContent
        this.formUpdModel.det_FormBody = this.pElement
        this.formUpdModel.sta_Form = this.dataEdit.sta_Form === 'activo' ? '1' : '0'
        this.formUpdModel.id_Role = this.dataEdit.roleId
        this.formUpdModel.id_Period = this.dataEdit.id_Period
        this.formUpdModel.id_Form_Type = this.dataEdit.formTypeId
      }
    },
    validatePeriod () {
      const value = this.formUpdModel.id_Period
      if (!/^\d+$/.test(value)) {
        this.formUpdModel.id_Period = ''
      } else {
        this.$refs.periodInput.setCustomValidity('')
      }

      if (this.formUpdModel.id_Period.length < 4 || this.formUpdModel.id_Period.length > 4) {
        const errorMessage = 'El período debe tener 4 dígitos.'
        this.$refs.periodInput.setCustomValidity(errorMessage)
      } else {
        this.$refs.periodInput.setCustomValidity('')
      }
    },
    validateFechaFin () {
      if (this.formUpdModel.date_Form_End < this.formUpdModel.date_Form_Start) {
        const errorMessage = 'Fecha de cierre no puede ser menor a Fecha de apertura.'
        this.$refs.fechaFinInput.setCustomValidity(errorMessage)
      } else {
        this.$refs.fechaFinInput.setCustomValidity('')
      }
    },
  },
  mounted () {
    this.loadDataSelectRoles()
    this.loadDataSelectTypeForm()
    this.loadEditInformation()
  },
  props: {
    dataEdit: Object,
    validationAction: Boolean,
  },
}
</script>